
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useUser } from '@/contexts/UserContext';

const SHOPPING_LIST_COUNT = 'shopping-list-count';

export const useShoppingListCount = () => {
  const { user } = useUser();

  return useQuery({
    queryKey: [SHOPPING_LIST_COUNT, user?.id],
    queryFn: async () => {
      if (!user) return 0;
      
      // Get the user's current family ID
      const { data: userData } = await supabase
        .from('profiles')
        .select('current_family_id')
        .eq('id', user.id)
        .single();
      
      if (!userData?.current_family_id) return 0;
      
      // Count shopping lists for this family
      const { count } = await supabase
        .from('shopping_lists')
        .select('*', { count: 'exact', head: true })
        .eq('family_id', userData.current_family_id);
      
      return count || 0;
    },
    enabled: !!user,
  });
};
